import {FC} from 'react';
import {Modal as MantineModal} from '@mantine/core';
import clsx from 'clsx';

import {BaseModalProps} from './types';
import s from './styles.module.scss';

// TODO: check size param
const BaseModal: FC<BaseModalProps> = ({
  children,
  opened,
  onClose,
  size,
  title,
  className,
  classNames,
  withBottomPadding = true,
  centered = true,
  withCloseButton = true,
  closeOnClickOutside = true,
  transition = 'slide-up',
}) => (
  <MantineModal
    opened={opened}
    onClose={onClose}
    size={size ?? 'fit-content'}
    transitionProps={{transition}}
    centered={centered}
    closeOnClickOutside={closeOnClickOutside}
    withCloseButton={withCloseButton}
    data-testid="dialog"
    classNames={{
      inner: clsx(
        s['modal-inner'],
        {
          [s['modal-inner--centered']]: centered,
        },
        classNames?.inner
      ),
      content: clsx(
        s['modal-content'],
        {
          [s['modal-content--no-padding']]: !withBottomPadding,
        },
        className
      ),
      header: s['modal-header'],
      title: s['modal-title'],
      body: clsx(s['modal-body'], classNames?.body),
      close: s['close-button'],
    }}
  >
    {title && <div className={clsx(s['modal-title'], classNames?.title)}>{title}</div>}
    {children}
  </MantineModal>
);

export default BaseModal;
